import styled from "styled-components";

export const TestimonialWrapper = styled.div`
  padding: 50px 0px;
  @media (max-width: 992px) {
    padding: 50px 20px;
  }
`;
export const TestimonialTitle = styled.h4`
  font-size: 22px;
  margin: 0;
  font-weight: 600;
  padding-top: 15px;
`;
export const TestimonialDescription = styled.p`
  color: #716c80;
  margin: 0;
  font-size: 14px;
  line-height: 2;
  padding-bottom: 40px;
`;
export const TestimonialImage = styled.img`
  border-radius: 5px;
  max-height: 400px;
  height: 100%;
  object-fit: cover;
`;
export const PersonDetail = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  padding: 0;
  padding-top: 20px;
`;
